/**
 * @generated SignedSource<<7a14d137edcae9c1982589fd965f2c65>>
 * @relayHash e52128060082408adaecdfb25c536f58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90c47693682b832b0e54d154b0655ad98997a7b531e9ec0a6b459682b9ab70b9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogMetaAPIConsumerWrapperQuery } from './BacklogMetaAPIConsumerWrapperQuery.graphql';

const node: PreloadableConcreteRequest<BacklogMetaAPIConsumerWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "90c47693682b832b0e54d154b0655ad98997a7b531e9ec0a6b459682b9ab70b9",
    "metadata": {},
    "name": "BacklogMetaAPIConsumerWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
